import React, { useState, useMemo } from "react";
import { Link } from "react-router-dom";
import "./BikeParts.css";
import Price from "../Price";
import PartImage from "../PartImage";
import { Parts, PART_CATEGORIES } from "../.././Parts";

const FILTERS = ["All", ...PART_CATEGORIES];

const SORTS = {
  featured: { label: "Featured", fn: null },
  priceAsc: { label: "Price: low to high", fn: (a, b) => a.Price - b.Price },
  priceDesc: { label: "Price: high to low", fn: (a, b) => b.Price - a.Price },
  name: { label: "Name A–Z", fn: (a, b) => a.Brand.localeCompare(b.Brand) },
};

export default function BikeParts() {
  const [active, setActive] = useState("All");
  const [sort, setSort] = useState("featured");

  const counts = useMemo(() => {
    const c = { All: Parts.length };
    for (const cat of PART_CATEGORIES) {
      c[cat] = Parts.filter((p) => p.Category === cat).length;
    }
    return c;
  }, []);

  const parts = useMemo(() => {
    const list =
      active === "All" ? [...Parts] : Parts.filter((p) => p.Category === active);
    const fn = SORTS[sort].fn;
    return fn ? list.sort(fn) : list;
  }, [active, sort]);

  return (
    <div className="container-fluid d-flex justify-content-center py-3" id="Parts">
      <div className="Parts_list p-3">
        <h3>Bicycle parts &amp; accessories in Patna</h3>
        <p className="rg-catalog-note">
          Genuine EMotorad accessories — headlights, pumps, locks, helmets,
          mudguards and mounts. All prices in Indian Rupees (INR / ₹), inclusive
          of GST. Electrical components cannot be exchanged once opened or
          fitted — see our{" "}
          <Link to="/warranty-returns">Warranty &amp; Returns Policy</Link>.
        </p>

        <div className="parts-toolbar">
          <div className="filtering" role="group" aria-label="Filter by category">
            <span>Filter</span>
            {FILTERS.map((cat) => (
              <button
                key={cat}
                type="button"
                className={
                  "btn btn-light border" + (active === cat ? " is-active" : "")
                }
                aria-pressed={active === cat}
                onClick={() => setActive(cat)}
              >
                {cat}
                <span className="filter-count">{counts[cat]}</span>
              </button>
            ))}
          </div>

          <label className="parts-sort">
            <span>Sort</span>
            <select value={sort} onChange={(e) => setSort(e.target.value)}>
              {Object.entries(SORTS).map(([key, s]) => (
                <option key={key} value={key}>
                  {s.label}
                </option>
              ))}
            </select>
          </label>
        </div>

        <p className="parts-result-count">
          Showing {parts.length} {parts.length === 1 ? "product" : "products"}
          {active !== "All" ? ` in ${active}` : ""}
        </p>

        <div className="cycle-row">
          {parts.map((element) => (
            <div className="card my-2" key={element.id}>
              <PartImage
                src={element.image}
                alt={element.Brand}
                className="card-img-top"
              />
              <div className="card-body">
                <span className="part-category">{element.Category}</span>
                <span className="card-title">{element.Brand}</span>
                <Price value={element.Price} note={false} />
                <p className="part-feature">{element.Features}</p>
                <Link
                  type="button"
                  className="btn btn-light border"
                  to={`/Part_catalog/${element.id}`}
                >
                  View details
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
